enum Tab {
  ALL = "all",
  RECENT = "recent",
  FUNNEL = "funnel",
  LEAD = "lead",
  FOLLOW_UPS = "follow_ups",
}

export default Tab;